export const CREATE_CASE = 'CREATE_CASE';
export const CREATE_CASE_SUCCESS = 'CREATE_CASE_SUCCESS';
export const CREATE_CASE_FAIL = 'CREATE_CASE_FAIL';
export const CREATE_CASE_INFO_MODAL_CLOSE = 'CREATE_CASE_INFO_MODAL_CLOSE';
export const UPDATE_CASE = 'UPDATE_CASE';
export const UPDATE_CASE_SUCCESS = 'UPDATE_CASE_SUCCESS';
export const UPDATE_CASE_FAIL = 'UPDATE_CASE_FAIL';

export const createCase = ({ name, note, customers, dept, customFields }) => ({
  type: CREATE_CASE,
  payload: { name, note, customers, dept, customFields }
});

export const createCaseSuccess = ({ caseId }) => ({
  type: CREATE_CASE_SUCCESS,
  payload: { caseId }
});

export const createCaseFail = (message) => ({
  type: CREATE_CASE_FAIL,
  payload: { message }
});

export const createCaseInfoModalClose = () => ({
  type: CREATE_CASE_INFO_MODAL_CLOSE
});

export const updateCase = ({
  caseId,
  name,
  note,
  customers,
  dept,
  customFields
}) => ({
  type: UPDATE_CASE,
  payload: { caseId, name, note, customers, dept, customFields }
});

export const updateCaseSuccess = ({ caseId }) => ({
  type: UPDATE_CASE_SUCCESS,
  payload: { caseId }
});

export const updateCaseFail = (message) => ({
  type: UPDATE_CASE_FAIL,
  payload: { message }
});
